import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface TranslationStatus {
  needsUpdate: boolean;
  frenchTimestamp: Date | null;
  currentTimestamp: Date | null;
}

export const useTranslationStatus = (
  table: 'cms_content',
  key: string,
  language: string
) => {
  const [status, setStatus] = useState<TranslationStatus>({
    needsUpdate: false,
    frenchTimestamp: null,
    currentTimestamp: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkStatus = async () => {
      if (language === 'fr') {
        setStatus({ needsUpdate: false, frenchTimestamp: null, currentTimestamp: null });
        setLoading(false);
        return;
      }

      try {
        // Récupérer le contenu dans la langue courante
        const { data: currentContent } = await supabase
          .from(table)
          .select('updated_at, french_version_timestamp')
          .eq('key', key)
          .eq('language', language)
          .maybeSingle() as any;

        if (!currentContent) {
          setStatus({ needsUpdate: false, frenchTimestamp: null, currentTimestamp: null });
          setLoading(false);
          return;
        }

        const currentUpdated = new Date(currentContent.updated_at);
        const frenchVersion = currentContent.french_version_timestamp 
          ? new Date(currentContent.french_version_timestamp)
          : null;

        // Si le timestamp français est plus récent que la dernière modification, retraduction nécessaire
        const needsUpdate = frenchVersion !== null && frenchVersion > currentUpdated;

        setStatus({
          needsUpdate,
          frenchTimestamp: frenchVersion,
          currentTimestamp: currentUpdated,
        });
      } catch (error) {
        console.error('Error checking translation status:', error);
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
  }, [table, key, language]);

  return { ...status, loading };
};
